import { CSSProperties } from "react";
import {
  BrandKit,
  ButtonStyleDefinition,
  Enableable,
  InputStyleDefinition,
  Override,
  styleFromFontWeight,
} from "../brand-kit";
import { ButtonHierarchy } from "../content-builder/element-schema";
import { fontWeightValues } from "../signup-form";
import { getFontFamilyWithFallback } from "./font-utils";

export function getButtonStyles({
  brandKit,
  hierarchy,
  override: _override,
  fullWidth = true,
}: {
  brandKit: BrandKit;
  hierarchy: ButtonHierarchy;
  override?:
    | Override<ButtonStyleDefinition>
    | Enableable<Override<ButtonStyleDefinition>>;
  fullWidth?: boolean;
}): CSSProperties {
  const override =
    _override && "enabled" in _override && !_override.enabled
      ? undefined
      : _override;
  const styles = override ? override : brandKit?.buttons[hierarchy];
  return {
    outline: "0px",
    backgroundColor: styles.backgroundColor ?? undefined,
    color: styles.textColor,
    border: `${styles.border.stroke.weightPx}px solid ${styles.border.stroke.color}`,
    borderRadius: `${styles.border.cornerRadiusPx}px`,
    width: fullWidth ? "100%" : "auto",
    fontFamily: getFontFamilyWithFallback(
      "fontReference" in styles
        ? brandKit?.font.bodyFontFamily
        : styles.font.fontFamily,
      brandKit?.customFontFamilies,
    ),
    fontSize: `${"fontReference" in styles ? brandKit?.font.hierarchy[styles.fontReference].fontSizePx : styles.font.fontSizePx}px`,
    fontWeight: styleFromFontWeight(
      "fontReference" in styles
        ? brandKit?.font.hierarchy[styles.fontReference].fontWeight
        : styles.font.fontWeight,
    ),
    padding: `${styles.paddingPx}px`,
    cursor: "pointer",
  };
}

export function getInputStyles(
  brandKit: BrandKit,
  _override?:
    | Override<InputStyleDefinition>
    | Enableable<Override<InputStyleDefinition>>,
): React.CSSProperties {
  const override =
    _override && "enabled" in _override && !_override.enabled
      ? undefined
      : _override;
  const styles = override ?? brandKit?.inputs;

  return {
    backgroundColor: styles.backgroundColor ?? undefined,
    color: styles.textColor,
    borderWidth: `${styles.border.stroke.weightPx}px`,
    borderStyle: "solid",
    borderColor: styles.border.stroke.color,
    width: "100%",
    borderRadius: `${styles.border.cornerRadiusPx}px`,
    fontFamily: getFontFamilyWithFallback(
      "fontReference" in styles
        ? brandKit?.font.bodyFontFamily
        : styles.font.fontFamily,
      brandKit?.customFontFamilies,
    ),
    fontSize: `${"fontReference" in styles ? brandKit?.font.hierarchy[styles.fontReference].fontSizePx : styles.font.fontSizePx}px`,
    fontWeight:
      fontWeightValues[
        "fontReference" in styles
          ? brandKit?.font.hierarchy[styles.fontReference].fontWeight
          : styles.font.fontWeight
      ],
    padding: `${styles.paddingPx}px`,
  };
}
